import React from "react";
export const RemoteVideo = ({ isProfessional }) => {
  return (
    <div
      id="remote"
      className={`d-flex justify-content-center remote${
        isProfessional ? " remote--professional" : ""
      }`}
    ></div>
  );
};
